"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeQuerySort = void 0;
var IkeQuerySort;
(function (IkeQuerySort) {
    IkeQuerySort[IkeQuerySort["ASC"] = 1] = "ASC";
    IkeQuerySort[IkeQuerySort["DES"] = -1] = "DES";
})(IkeQuerySort || (exports.IkeQuerySort = IkeQuerySort = {}));
//# sourceMappingURL=query.sort.js.map